import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PROVIDER_GET_BY_ADDRESS_ID } from 'api/utilityActionTypes';

export default async function getUtilityProviderListByAddressIdAction(
  { state, utilityApiClient },
  { addressId, refresh } = {},
) {
  typeCheck('refresh::Maybe Boolean', refresh);

  const utilityProviderListStatePath = ['utilityProviders', 'byAddressId', addressId];

  if (!refresh && state.get(utilityProviderListStatePath)) {
    return state.get(utilityProviderListStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PROVIDER_GET_BY_ADDRESS_ID,
    state: state,
    payload: {
      addressId,
    },
    onSuccess(utilityProviderList) {
      state.set(utilityProviderListStatePath, utilityProviderList);
    },
  });
}
